import { useMutation, useQueryClient } from 'react-query';

import { updateTiltak } from '../../../../../services/api';
import { queryKeys } from '../../../../../utils/react-query';
import { Tiltak } from '../../../../../types/registration/tiltak';

export const useUpdateTiltak = (energiplanId: string | undefined) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation((tiltak: Tiltak) => updateTiltak({ ...tiltak, energiplanId }), {
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([queryKeys.energyplanMeasures, energiplanId]),
        queryClient.invalidateQueries([queryKeys.measures])
      ])
  });

  return { updateTiltak: mutate, isLoading };
};
